import React, { Component, Fragment } from 'react';
import CountdownTimer from './CountDownTimer';
import CreditCardPromoModal from './CreditCardReductionModal';
import PropTypes from 'prop-types';

class CreditCardReductionAlertCountdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    render() {
        const { isModalOpen } = this.state;
        const { targetDate } = this.props;

        return (
            <Fragment>
                <CreditCardPromoModal isOpen={isModalOpen} onClose={this.closeModal} />
                <div className="sprk-c-Alert sprk-c-Alert--info" role="alert" style={{ backgroundColor: '#ffffff', border: '2px solid #1c6ef2' }}>
                    <div className="sprk-c-Alert__content">
                        <svg className="sprk-c-Icon sprk-c-Icon--l sprk-c-Alert__icon sprk-c-Icon--stroke-current-color" viewBox="0 0 64 64">
                            <use href="#bell" data-sprk-toggle=""></use>
                        </svg>
                        <div className="sprk-c-Alert__text">
                            Don't miss out. Your $100 e-gift card offer expires in: <CountdownTimer targetDate={targetDate}/>.
                            <sup id='openPromoModal'
                                onClick={this.openModal}
                                style={{ cursor: 'pointer', color: 'black', textUnderlineOffset: '2px', textDecoration: 'underline' }}>
                                <span>&dagger;</span>
                            </sup>    
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

CreditCardReductionAlertCountdown.propTypes = {
    targetDate: PropTypes.string.isRequired,
};

export default CreditCardReductionAlertCountdown;
